<template>
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="15" fill="#6FD4BC"/>
        <line x1="8" y1="15.5" x2="23" y2="15.5" stroke="#0B3459" stroke-width="3"/>
    </svg>
</template>
<script>
    export default{}
</script>